import axios from 'axios'
import store from '../store'

const instance = axios.create({
  // baseURL: ''
})

// http request 拦截器
instance.interceptors.request.use(
  (config) => {
    const token = store.getters.token
    const con = config
    if (token) {
      con.headers.Authorization = token
    }
    return con
  },
  (err) => Promise.reject(err)
)

export default instance
